if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.bindLayoutInteractions();
        this.bindMobileNav();
      }

      bindLayoutInteractions() {
        this.layout = this.querySelector('.product-media-modal__layout');
        if (!this.layout || this.layoutInteractionsBound) return;

        this.layout.addEventListener('click', (event) => {
          const thumb = event.target.closest('.product-media-modal__thumb');
          if (thumb) {
            event.stopPropagation();
            this.setActiveMedia(thumb.dataset.mediaId);
            return;
          }

          const image = event.target.closest('.product-media-modal__stage img.active');
          if (!image) return;

          event.stopPropagation();
          this.toggleImageZoom(image, event);
        });

        this.layoutInteractionsBound = true;
      }

      bindMobileNav() {
        if (this.mobileNavBound) return;

        this.addEventListener('click', (event) => {
          const prev = event.target.closest('.product-media-modal__arrow--prev');
          const next = event.target.closest('.product-media-modal__arrow--next');

          if (prev && !prev.hasAttribute('disabled')) {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(-1);
            return;
          }

          if (next && !next.hasAttribute('disabled')) {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(1);
          }
        });

        this.mobileNavBound = true;
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__stage [data-media-id]')).filter(
          (element) => !element.classList.contains('product__media-item--variant')
        );
      }

      navigateMedia(direction) {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1) return;

        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= items.length) return;

        this.setActiveMedia(items[nextIndex].dataset.mediaId);
      }

      updateMobileNav(mediaId) {
        const items = this.getMediaItems();
        const index = items.findIndex((element) => element.dataset.mediaId === String(mediaId));
        const counter = this.querySelector('.product-media-modal__counter-current');
        const prev = this.querySelector('.product-media-modal__arrow--prev');
        const next = this.querySelector('.product-media-modal__arrow--next');

        if (counter && index !== -1) counter.textContent = String(index + 1);
        if (prev) prev.toggleAttribute('disabled', index <= 0);
        if (next) next.toggleAttribute('disabled', index >= items.length - 1);
      }

      resetImageZoom() {
        this.querySelectorAll('.product-media-modal__stage img.is-zoomed').forEach((image) => {
          image.classList.remove('is-zoomed');
          image.style.removeProperty('--zoom-scale');
          image.style.removeProperty('--zoom-origin-x');
          image.style.removeProperty('--zoom-origin-y');
        });
        this.querySelector('.product-media-modal__stage')?.classList.remove('is-zoomed');
      }

      toggleImageZoom(image, event) {
        const isZoomed = image.classList.contains('is-zoomed');
        this.resetImageZoom();

        if (isZoomed) return;

        const rect = image.getBoundingClientRect();
        const originX = ((event.clientX - rect.left) / rect.width) * 100;
        const originY = ((event.clientY - rect.top) / rect.height) * 100;

        image.style.setProperty('--zoom-origin-x', `${originX}%`);
        image.style.setProperty('--zoom-origin-y', `${originY}%`);
        image.style.setProperty('--zoom-scale', '2');
        image.classList.add('is-zoomed');
        this.querySelector('.product-media-modal__stage')?.classList.add('is-zoomed');
      }

      hide() {
        this.resetImageZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.querySelector(`.product-media-modal__stage [data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.resetImageZoom();

        this.querySelectorAll('.product-media-modal__stage [data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.querySelectorAll('.product-media-modal__thumb').forEach((button) => {
          const isActive = button.dataset.mediaId === String(mediaId);
          button.classList.toggle('is-active', isActive);
          if (isActive) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        const activeThumb = this.querySelector(`.product-media-modal__thumb[data-media-id="${mediaId}"]`);
        activeThumb?.scrollIntoView({ block: 'start', behavior: 'smooth' });

        this.updateMobileNav(mediaId);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      resolveMediaIdFromGallery(sectionId) {
        const activeSlide = document.querySelector(
          `#Slider-Gallery-${sectionId} li.is-active[data-media-id]`
        );
        if (!activeSlide?.dataset.mediaId) return null;

        const mediaKey = activeSlide.dataset.mediaId;
        const sectionPrefix = `${sectionId}-`;
        if (mediaKey.startsWith(sectionPrefix)) {
          return mediaKey.slice(sectionPrefix.length);
        }

        return mediaKey.split('-').pop();
      }

      showActiveMedia() {
        const sectionId = this.id.replace('ProductModal-', '');
        let mediaId = this.openedBy?.getAttribute('data-media-id');

        if (!mediaId) {
          mediaId = this.resolveMediaIdFromGallery(sectionId);
        }

        if (!mediaId) return;
        this.setActiveMedia(mediaId);
      }
    }
  );
}
